import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { PublicShell } from "@/components/shared";

const DOCS = {
  privacy: {
    title: "Privacy Policy",
    body: [
      ["Overview", "Shubham Bapna ('we', 'us') respects your privacy. This policy explains what data we collect and how we use it. This is placeholder content for demonstration; replace with legal-reviewed text before launch."],
      ["Information we collect", "Account details (name, email), profile information you provide, payment metadata processed by Razorpay/Stripe, and usage data such as resources downloaded and community activity."],
      ["How we use it", "To provide and improve the service, personalise resource recommendations, process payments, send transactional and newsletter emails, and keep the platform secure."],
      ["Data sharing", "We do not sell your data. We share limited data with processors (payments, email) strictly to operate the service."],
      ["Your rights", "You may request access, correction or deletion of your data by contacting support."],
    ],
  },
  terms: {
    title: "Terms of Service",
    body: [
      ["Acceptance", "By using this site you agree to these terms. Placeholder content for demonstration."],
      ["Membership", "Paid memberships (Builder, Growth Pro) grant access to gated resources, courses and community spaces per your active plan. Access ends if your subscription lapses."],
      ["Acceptable use", "Do not share account access, scrape content, or post harmful, illegal or spam content in the community."],
      ["Content", "Resources and courses are for your own business use. Redistribution is not permitted."],
      ["Liability", "The platform is provided 'as is'. We are not liable for business outcomes."],
    ],
  },
  affiliate: {
    title: "Affiliate Disclosure",
    body: [
      ["Disclosure", "Some links in our AI Tool Directory and articles are affiliate links. If you purchase through them, we may earn a commission at no additional cost to you."],
      ["Our promise", "We only recommend tools we genuinely believe help Indian founders. Affiliate relationships never change our honest assessment or rankings."],
      ["Transparency", "Affiliate links are labelled where relevant. Non-affiliate alternatives are always available via search."],
    ],
  },
  refund: {
    title: "Refund Policy",
    body: [
      ["Overview", "Placeholder refund policy for demonstration. Replace with your finalised terms."],
      ["Monthly plans", "Monthly memberships can be cancelled anytime and will not renew. We do not offer partial refunds for the current month."],
      ["Annual plans", "Annual memberships are eligible for a refund within 7 days of purchase if you are not satisfied, minus any transaction fees."],
      ["How to request", "Contact support with your account email to request a cancellation or refund."],
    ],
  },
};

export default function Legal() {
  const { doc } = useParams();
  const d = DOCS[doc];
  if (!d) return <Navigate to="/legal/privacy" replace />;
  return (
    <PublicShell>
      <section className="mx-auto max-w-3xl px-5 py-16 lg:px-8" data-testid={`legal-${doc}`}>
        <h1 className="font-heading text-4xl font-bold tracking-tight text-navy">{d.title}</h1>
        <p className="mt-2 text-sm text-slate-400">Last updated {new Date().toLocaleDateString()}</p>
        <div className="mt-8 space-y-8">
          {d.body.map(([h, p]) => (
            <div key={h}>
              <h2 className="font-heading text-xl font-semibold text-navy">{h}</h2>
              <p className="mt-2 leading-relaxed text-slate-700">{p}</p>
            </div>
          ))}
        </div>
      </section>
    </PublicShell>
  );
}
